import BaseService from '@/features/BaseService';

export default class CalledService extends BaseService {

  constructor() {
    super('called');
  }

}



// WEBPACK FOOTER //
// ./src/features/called/CalledService.js